export const tagColors = [
  // Group 1: Colors 1-4 (Dark shades with subtle differences)
  "#A500A1", // Dark Magenta
  "#A10000", // Dark Red
  "#A14D24", // Dark Volcano
  "#A15B30", // Dark Orange
  
  // Group 2: Colors 5-6 (Similar shades)
  "#B8860B", // Dark Goldenrod
  "#A8D600", // Dark Lime Green
  
  // Group 3: Colors 7-8 (Slightly varied greens)
  "#005700", // Dark Green
  "#007A7A", // Dark Cyan
  
  // Group 4: Colors 9-12 (Blue variations)
  "#00008B", // Dark Blue
  "#1E3A8A", // Dark Slate Blue
  "#4B0082", // Indigo
  "#DDA0DD", // Dark Plum
  
  // Group 5: Colors 13-14 (Pink variations)
  "#8B008B", // Dark Magenta
  "#C71585", // Medium Violet Red
  
  // Group 6: Colors 16-17 (Red variations)
  "#CD5C5C", // Indian Red
  "#A0522D", // Sienna
  
  // Group 7: Colors 18-19 (Blue variations)
  "#4169E1", // Royal Blue
  "#483D8B", // Dark Slate Blue
  
  // Group 8: Colors 20-21 (Brown variations)
  "#8B4513", // Saddle Brown
  "#C2B280", // Khaki
  
  // Group 9: Colors 22-25 (Bright variations)
  "#FF6347", // Tomato
  "#2E8B57", // Sea Green
  "#3CB371", // Medium Sea Green
  "#FFB6C1", // Light Pink
  
  // Additional Colors 26-30
  "#556B2F", // Dark Olive Green
  "#708090", // Slate Gray
  "#8B0000", // Dark Red (variation)
  "#2F4F4F", // Dark Slate Gray
  "#4682B4", // Steel Blue
  "#D2691E", // Chocolate
  "#F0E68C", // Khaki (Light)
  "#FF4500", // Orange Red
  "#9B30FF", // Medium Orchid
  "#B22222"  // Firebrick
];

export const lineColors = [
  // Group 1: Colors 1-4 (Dark shades with subtle differences)
  "#A500A1", // Dark Magenta
  "#A10000", // Dark Red
  "#A14D24", // Dark Volcano
  "#A15B30", // Dark Orange
  
  // Group 2: Colors 5-6 (Similar shades)
  "#B8860B", // Dark Goldenrod
  "#A8D600", // Dark Lime Green
  
  // Group 3: Colors 7-8 (Slightly varied greens)
  "#005700", // Dark Green
  "#007A7A", // Dark Cyan
  
  // Group 4: Colors 9-12 (Blue variations)
  "#00008B", // Dark Blue
  "#1E3A8A", // Dark Slate Blue
  "#4B0082", // Indigo
  "#DDA0DD", // Dark Plum
  
  // Group 5: Colors 13-14 (Pink variations)
  "#8B008B", // Dark Magenta
  "#C71585", // Medium Violet Red
  
  // Group 6: Colors 16-17 (Red variations)
  "#CD5C5C", // Indian Red
  "#A0522D", // Sienna
  
  // Group 7: Colors 18-19 (Blue variations)
  "#4169E1", // Royal Blue
  "#483D8B", // Dark Slate Blue
  
  // Group 8: Colors 20-21 (Brown variations)
  "#8B4513", // Saddle Brown
  "#C2B280", // Khaki
  
  // Group 9: Colors 22-25 (Bright variations)
  "#FF6347", // Tomato
  "#2E8B57", // Sea Green
  "#3CB371", // Medium Sea Green
  "#FFB6C1", // Light Pink
  
  // Additional Colors 26-30
  "#556B2F", // Dark Olive Green
  "#708090", // Slate Gray
  "#8B0000", // Dark Red (variation)
  "#2F4F4F", // Dark Slate Gray
  "#4682B4", // Steel Blue
  "#D2691E", // Chocolate
  "#F0E68C", // Khaki (Light)
  "#FF4500", // Orange Red
  "#9B30FF", // Medium Orchid
  "#B22222"  // Firebrick
];
